import React from 'react'
import gql from 'graphql-tag'
import { Query, Mutation } from 'react-apollo'

export const stigTemplateDetailsQuery = gql`
  query StigTemplateDetails($organizationID: ID!, $applicationID: ID!) {
    stigTemplate(
      organizationID: $organizationID
      applicationID: $applicationID
    ) {
      name
      created
    }
  }
`

export interface StigTemplateDetails {
  readonly name: string
  readonly created: Date
}

interface StigTemplateDetailsQueryProps {
  readonly organizationID: string
  readonly applicationID: string
  readonly children: (props: {
    readonly details?: StigTemplateDetails
  }) => React.ReactNode
}

export function StigTemplateDetailsQuery({
  organizationID,
  applicationID,
  children
}: StigTemplateDetailsQueryProps) {
  return (
    <Query<
      {
        readonly stigTemplate?: StigTemplateDetails
      },
      {
        readonly organizationID: string
        readonly applicationID: string
      }
    >
      query={stigTemplateDetailsQuery}
      variables={{
        applicationID,
        organizationID
      }}
      fetchPolicy="network-only"
    >
      {({ data, loading }) => {
        if (loading) {
          return <React.Fragment />
        }

        return children({
          details: !!data ? data.stigTemplate : undefined
        })
      }}
    </Query>
  )
}

export const persistStigTemplateMutation = gql`
  mutation PersistStigTemplate(
    $organizationID: ID!
    $applicationID: ID!
    $name: String!
    $fileType: String!
    $content: String!
  ) {
    persistStigTemplate(
      input: {
        organizationID: $organizationID
        applicationID: $applicationID
        name: $name
        fileType: $fileType
        content: $content
      }
    ) {
      _placeholder
    }
  }
`

interface MutationResponse {
  readonly _placeholder: boolean
}

interface MutationVars {
  readonly organizationID: string
  readonly applicationID: string
  readonly name: string
  readonly fileType: string
  readonly content: string
}

interface PersistStigTemplateMutationProps {
  readonly children: (props: {
    readonly persistStigTemplate: (args: MutationVars) => Promise<any>
  }) => React.ReactNode
}

export function PersistStigTemplateMutation({
  children
}: PersistStigTemplateMutationProps) {
  return (
    <Mutation<MutationResponse, MutationVars>
      mutation={persistStigTemplateMutation}
    >
      {(persistStigTemplate) =>
        children({
          persistStigTemplate: (args) =>
            persistStigTemplate({ variables: args })
        })
      }
    </Mutation>
  )
}
